import { render, staticRenderFns } from "./MaidPremium.vue?vue&type=template&id=61dabe84&"
import script from "./MaidPremium.vue?vue&type=script&lang=js&"
export * from "./MaidPremium.vue?vue&type=script&lang=js&"
import style0 from "./MaidPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidPremium.vue"
export default component.exports